"use client";

import { Turnstile, type TurnstileInstance } from "@marsidev/react-turnstile";
import { forwardRef, useImperativeHandle, useRef } from "react";

import { getTurnstileSiteKey } from "@/shared/lib/turnstile/config";

import styles from "./TurnstileField.module.css";

export type TurnstileFieldHandle = {
  reset: () => void;
};

type TurnstileFieldProps = {
  onSuccess: (token: string) => void;
  onExpire?: () => void;
  onError?: () => void;
};

export const TurnstileField = forwardRef<
  TurnstileFieldHandle,
  TurnstileFieldProps
>(function TurnstileField({ onSuccess, onExpire, onError }, ref) {
  const turnstileRef = useRef<TurnstileInstance>(null);
  const siteKey = getTurnstileSiteKey();

  useImperativeHandle(ref, () => ({
    reset: () => turnstileRef.current?.reset(),
  }));

  if (!siteKey) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <Turnstile
        ref={turnstileRef}
        siteKey={siteKey}
        onSuccess={onSuccess}
        onExpire={onExpire}
        onError={onError}
        options={{
          theme: "light",
          size: "flexible",
        }}
      />
    </div>
  );
});
